import { render, staticRenderFns } from "./FrasesSga.vue?vue&type=template&id=096aff52&scoped=true"
import script from "./FrasesSga.vue?vue&type=script&lang=js"
export * from "./FrasesSga.vue?vue&type=script&lang=js"
import style0 from "./FrasesSga.vue?vue&type=style&index=0&id=096aff52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "096aff52",
  null
  
)

export default component.exports